<!-- Option select -->
<div class="row" *ngIf="!(result | async)">
  <div class="col-md-6" *ngIf="(orderOptions | async | orderOptionFilter: isJobsiteOption)?.length > 0">
    <div *ngIf="viewOptions.jobsite.enabled">
      <cwc-picker
        [label]="'views.location.select_existing_jobsite' | translate"
        (cwcChange)="jobsiteOrderSelected($event.detail)"
        designVersion="v2"
      >
        <cwc-picker-option *ngFor="let order of orderOptions | async | orderOptionFilter: isJobsiteOption" [value]="order" designVersion="v2">
          {{ order.jobsite.jobsiteCode }} - {{ order.jobsite.jobsiteDesc }}
        </cwc-picker-option>
      </cwc-picker>

    </div>
  </div>
  <div *ngIf="(orderOptions | async | orderOptionFilter: isPointOfDeliveryOption)?.length > 0" class="col-md-6">
    <div *ngIf="viewOptions.pointOfDelivery.enabled">
      <cwc-picker [label]="'views.details.pod' | translate" (cwcChange)="pointOfDeliveryOrderSelected($event.detail)" designVersion="v2">
        <cwc-picker-option
          *ngFor="let order of orderOptions | async | orderOptionFilter: isPointOfDeliveryOption"
          [value]="order"
          designVersion="v2"
        >
          {{ order.pointOfDelivery.pointOfDeliveryCode }} - {{ order.pointOfDelivery.pointOfDeliveryDesc }}
        </cwc-picker-option>
      </cwc-picker>
    </div>
  </div>
</div>

<hr *ngIf="!(result | async)" />
